import { Timestamp } from '@britishcouncil/common-core';
import {
  CentreTypeSelector,
  api,
  CertificationsDueReportResponse,
  PagedResultOfCertificationsDueReportResponse,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { CertificationDueReportFilterType } from './CertificationDueReportTypes';
import {
  getBcCentresIds,
  getIdpCentresIds,
  getPaginationParameters,
  getQueryStringParameters,
} from 'utils';

type ReportParams = TableState<CertificationsDueReportResponse, CertificationDueReportFilterType>;
const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      startDate: Timestamp.toISOString(params.filters.date[0]),
      endDate: Timestamp.toISOString(params.filters.date[1]),
      certificationTypes: params.filters.certificationTypes ?? [],
      regions: params.filters.regionsIds ?? [],
      countries: params.filters.countriesIds ?? [],
      centres: getBcCentresIds(params.filters.centresIds),
      idpCentres: getIdpCentresIds(params.filters.centresIds),
      centreType: params.filters.centreType ?? CentreTypeSelector.ALL,
    },
  };
};

export const certificationsDueReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getCertificationsDueRecords: builder.query<
      PagedResultOfCertificationsDueReportResponse,
      ReportParams
    >({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.certificationsDueReport.getCertificationsDueReport(input);
      },
    }),
    generateCertificationsDuePdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.certificationsDueReport.getCertificationsDuePdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateCertificationsDueExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.certificationsDueReport.getCertificationsDueExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetCertificationsDueRecordsQuery,
  useGenerateCertificationsDuePdfReportMutation,
  useGenerateCertificationsDueExcelReportMutation,
} = certificationsDueReportApi;
